import { useQuery } from '@tanstack/react-query';

import { useApi } from 'hooks/ApiStoreContext';

export function useFetchMicroServicesName() {
  const controllerApi = useApi().AdminFonctionnelControllerApi;

  const fetchMicroServicesName = (): Promise<string[]> => {
    return controllerApi.getAllMicroServiceNamesUsingGET();
  };

  const result = useQuery({
    queryKey: ['microServicesNames'],
    queryFn: fetchMicroServicesName,
  });

  return result.data;
}
